/* eslint-disable no-undef */
import { Common, color } from '@stockbit/ui';
import Link from 'next/link';
import CorpActionTag from './CorpActionTag';
import { BarWrapper, IconArrow } from './styled';

const { Flex, Text } = Common;

interface CorpActionBarProps {
  symbol: string;
  corpAction: Record<string, any>;
  isGuestCompanyStock?: boolean;
  onClick?: (...args) => void;
}

function CorpActionBar({ symbol, corpAction, isGuestCompanyStock = false, onClick }: CorpActionBarProps) {

  const onClickLink = (event) => {
    isGuestCompanyStock ? onClick(event) : false;
  };

  return (
    <Link href={`/symbol/${symbol}/corpaction`} passHref>
      <a onClick={onClickLink}>
        <BarWrapper>
          <Flex align="center">
            <CorpActionTag corpAction={corpAction} />
            <Text as="span" color={color.highempahis} weight="600" ml="8px" size="12px">
              Perusahaan memiliki Corporate Action
            </Text>
          </Flex>
          <IconArrow as="span" />
        </BarWrapper>
      </a>
    </Link>
  );
}

export default CorpActionBar;
